import { render, staticRenderFns } from "./WarehouseDeliveryPage.vue?vue&type=template&id=701e3814&scoped=true"
import script from "./WarehouseDeliveryPage.vue?vue&type=script&lang=ts"
export * from "./WarehouseDeliveryPage.vue?vue&type=script&lang=ts"
import style0 from "./WarehouseDeliveryPage.vue?vue&type=style&index=0&id=701e3814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e3814",
  null
  
)

export default component.exports